// extracted by mini-css-extract-plugin
export default {"container":"SpotlightHeader-module--container--ItKN3","subtitle":"SpotlightHeader-module--subtitle--5BGml"};